import { TextFieldMultipleController } from './text-field.multiple.controller';
import { TextFieldMultipleProps } from './text-field.multiple.model';

export const TextFieldMultiple = (props: TextFieldMultipleProps) => {
  return <TextFieldMultipleController {...props} />;
};
